import * as React from 'react';
export const fnboSvg = React.forwardRef(function fnboSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#026FAA',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M5.435 12.86C3.377 20.294 8.907 27 16.005 27c.637 0 1.246-.049 1.862-.147v-16.78h-2.54c-.855 2.276-3.032 2.255-3.032 2.255v2.324h1.96v8.883C10 22.534 7.066 17.955 8.823 13.14a7.156 7.156 0 0 1 4.256-4.285c5.481-2.058 10.64 1.96 10.64 7.169a7.701 7.701 0 0 1-4.746 7.119v3.5c4.649-1.323 8.05-5.58 8.05-10.64 0-7.091-7.023-12.503-14.16-10.57-3.642.985-6.468 3.908-7.428 7.427Z',
      fill: '#fff',
    }),
  );
});
fnboSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var fnbo = {
  category: 'brand',
  colorable: false,
  name: 'fnbo',
  svg: fnboSvg,
};
